import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import { Link as link } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import { Creators as SubscriptionCreators } from '../../../store/ducks/subscription';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';

import { siteParams } from '../../../config/site';

import Loading from '../../../components/Loading';
import LogoNextel from '../../../assets/images/assinatura-logo-nextel.png';
import LogoVivo from '../../../assets/images/assinatura-logo-vivo.png';

const LinkNotStyled = styled(link)``;
const Link = styled(link)`
  float: right;
  font-size: 14px;
`;

class Subscription extends Component {
  static propTypes = {
    getSubscriptionMobileRequest: PropTypes.func.isRequired,
    user: PropTypes.shape.isRequired,
    subscription: PropTypes.shape.isRequired,
  };

  state = {
    cancelAlert: false,
  };
  viewSubscriptionNone = () => (
    <div>
      <h5>Você não é assinante.</h5>
      <p>
        Assine e tenha acesso a um extenso catálogo de jornais para você ler a qualquer hora, em
        qualquer lugar.
      </p>
      <LinkNotStyled to="/credit-card" className="btn btn-primary">
        Assinar
      </LinkNotStyled>
    </div>
  );

  viewSubscriptionVoucher = () =>
    this.props.subscription.subscription.data && (
      <div>
        <p>
          <strong>Voucher</strong>
        </p>
        {this.expirationDateMessage()}
        <p>
          <Link to="/admin/vouchers">Ver detalhes</Link>
        </p>
      </div>
    );

  viewSubscriptionMobile = () =>
    this.props.subscription.subscription.data && (
      <div>
        <p>
          <strong>Celular</strong>
        </p>
        {this.getMobileSubscriptionsDetails()}
        {this.expirationDateMessage()}
        {this.getMobileCancelMessage()}
      </div>
    );

  getMobileSubscriptionsDetails = () => {
    if (this.props.subscription.subscriptionMobile) {
      if (this.props.subscription.subscriptionMobile.data.billingCode === '31') {
        return this.getMobileSubscriptionsDetailsNextel();
      } else if (this.props.subscription.subscriptionMobile.data.billingCode === '50') {
        return this.getMobileSubscriptionsDetailsVivo();
      }
    }
  };

  getMobileCancelMessage = () => {
    if (this.props.subscription.subscriptionMobile) {
      if (this.props.subscription.subscriptionMobile.data.billingCode === '31') {
        return this.getMobileCancelMessageNextel();
      } else if (this.props.subscription.subscriptionMobile.data.billingCode === '50') {
        return this.getMobileCancelMessageVivo();
      }
    }
  };

  getMobileSubscriptionsDetailsNextel = () => (
    <div>
      <p>
        <img height="35px" src={LogoNextel} alt="" />
        <br />
        {this.props.user.ddd} {this.props.user.phone}
      </p>
    </div>
  );

  getMobileCancelMessageNextel = () => (
    // if (
    //   this.props.subscription.subscriptionMobile.data.expire_date &&
    //   this.props.subscription.subscriptionMobile.data.expires === 'yes'
    // ) {
    //   return (
    //     <p>Para CANCELAR, envie um SMS para 23226 com a palavra SAIR.</p>
    //   )
    // }
    <div />
  );

  getMobileSubscriptionsDetailsVivo = () => (
    <div>
      <p>
        <img height="35px" src={LogoVivo} alt="" />
        <br />
        {this.props.user.ddd} {this.props.user.phone}
      </p>
    </div>
  );

  getMobileCancelMessageVivo = () => (
    <p>
      <Button onClick={() => this.setState({ cancelAlert: true })}> Cancelar assinatura</Button>
    </p>
  );

  viewSubscriptionCreditCard = () =>
    this.props.subscription.subscription.data && (
      <div>
        <p>
          <strong>Cartão de Crédito</strong>
        </p>
        {this.expirationDateMessage()}
        <Button onClick={() => this.setState({ cancelAlert: true })}> Cancelar assinatura</Button>
      </div>
    );
  
  viewSubscriptionMobileStore = () =>
    this.props.subscription.subscription.data && (
      <div>
        <p>
          <strong>Assinante</strong>
        </p>
        {this.expirationDateMessage()}
      </div>
    );

  expirationDateMessage = () => {
    if (this.props.subscription.subscription.data.via === 'mobile') {
      if (
        !this.props.subscription.subscriptionMobile.loading &&
        this.props.subscription.subscriptionMobile
      ) {
        if (
          !this.props.subscription.subscriptionMobile.data.expire_date &&
          this.props.subscription.subscriptionMobile.data.expires === 'no'
        ) {
          return <p>Sua assinatura está ativa.</p>;
        }

        const dt = new Date(this.props.subscription.subscriptionMobile.data.expire_date);
        const dtNow = new Date(Date.now());

        if (dt < dtNow) {
          return (
            <p>
              Sua assinatura expirou em{' '}
              <strong>
                <Moment
                  date={this.props.subscription.subscriptionMobile.data.expire_date}
                  format="DD/MM/YYYY"
                />
              </strong>. Aguardando pagamento.
            </p>
          );
        }

        if (
          this.props.subscription.subscriptionMobile.data.status === 'canceled' &&
          this.props.subscription.subscriptionMobile.data.expires === 'yes'
        ) {
          return (
            <p>
              Sua assinatura está cancelada, mas seu acesso expira somente em{' '}
              <strong>
                <Moment
                  date={this.props.subscription.subscriptionMobile.data.expire_date}
                  format="DD/MM/YYYY"
                />
              </strong>.
            </p>
          );
        }

        return (
          <p>
            Sua assinatura está ativa. Seu acesso expira em{' '}
            <strong>
              <Moment
                date={this.props.subscription.subscriptionMobile.data.expire_date}
                format="DD/MM/YYYY"
              />
            </strong>.
          </p>
        );
      }
      return <div />;
    }

    const dt = new Date(this.props.subscription.subscription.data.expire_date);
    const dtNow = new Date(Date.now());

    if (dt < dtNow) {
      return (
        <p>
          Sua assinatura expirou em{' '}
          <strong>
            <Moment
              date={this.props.subscription.subscription.data.expire_date}
              format="DD/MM/YYYY"
            />
          </strong>.
        </p>
      );
    }

    return (
      <p>
        Sua assinatura está ativa. Seu acesso expira em{' '}
        <strong>
          <Moment
            date={this.props.subscription.subscription.data.expire_date}
            format="DD/MM/YYYY"
          />
        </strong>.
      </p>
    );
  };

  isCreditCard = () => !this.props.subscription.subscription.loading &&
    this.props.subscription.subscription.data.via === 'credit_card';

  isMobileStore = () => !this.props.subscription.subscription.loading &&
    this.props.subscription.subscription.data.via === 'mobile_store';

  render() {
    return (
      <Fragment>
        <h1 className="title-underline">
          Assinatura
          {this.isCreditCard() && (
            <Link to="/admin/cards" style={{ float: 'right', fontSize: '14px' }}>
              Meus cartões
            </Link>
          )}
        </h1>

        {this.props.subscription.subscription.loading && <Loading />}

        {
          // NÃO POSSUI ASSINATURA
        }

        {!this.props.subscription.subscription.loading &&
          !this.props.subscription.subscription.data.via &&
          this.viewSubscriptionNone()}

        {
          // CARTÃO DE CRÉDITO
        }

        {this.isCreditCard() && this.viewSubscriptionCreditCard()}

        {
          // Mobile Store
        }
        {this.isMobileStore() && this.viewSubscriptionMobileStore()}

        {
          // VOUCHER
        }
        {!this.props.subscription.subscription.loading &&
          this.props.subscription.subscription.data.via === 'voucher' &&
          this.viewSubscriptionVoucher()}

        {
          // MOBILE
        }
        {!this.props.subscription.subscription.loading &&
          this.props.subscription.subscription.data.via === 'mobile' &&
          this.viewSubscriptionMobile()}

        {this.props.subscription.subscriptionMobile &&
          this.props.subscription.subscriptionMobile.data.status === 'canceled' &&
          !this.props.subscription.subscriptionMobile.data.expired && (
            <p>
              Cancelada em <strong>{this.props.subscription.subscription.data.canceled_at}</strong>.
            </p>
          )}
        <SweetAlert
          type="info"
          show={this.state.cancelAlert}
          title="Confirme o cancelamento da sua assinatura"
          onConfirm={() => {
            this.props.cancelSubscription();
            this.setState({ cancelAlert: false });
          }}
          onCancel={() => this.setState({ cancelAlert: false })}
          showCancelButton
          focusConfirm={false}
          cancelButtonText="Fechar"
          confirmButtonText="Confirmar"
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  subscription: state.subscription,
  user: state.user,
});

const mapDispatchToProps = dispatch => bindActionCreators(SubscriptionCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Subscription);



// WEBPACK FOOTER //
// ./src/pages/admin/subscription/index.js